// @flow
import * as React from "react";
import { useEffect } from "react";
import classes from "./ModalBaseStyles.module.scss";
import { ReactComponent as CloseIcon } from "./images/closeIcon.svg";

type Props = {
  children: JSX.Element;
  onClose: () => void;
  title?: string;
  hideCloseButton?: boolean;
};
export const ModalBase = ({ children, title, onClose, hideCloseButton }: Props) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <>
      <div className={classes.root} onClick={onClose}></div>
      <div className={classes.modalWrapper}>
        <div className={classes.modal}>
          <div className={classes.header}>
            <h2 className={classes.title}>{title}</h2>
            {!hideCloseButton && (
              <button onClick={onClose} className={classes.closeButton}>
                <CloseIcon />
              </button>
            )}
          </div>
          <div className={classes.contentWrapper}>{children}</div>
        </div>
      </div>
    </>
  );
};
